@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.passenger.login

import com.narbase.letsgo.router.EndPoint


object SubmitPhoneEndpoint : EndPoint<SubmitPhoneEndpoint.Request, SubmitPhoneEndpoint.Response>() {
    class Request (
        val phone: String
    )

    class Response(
        val hasAccount: Boolean
    )
}

